import { render, staticRenderFns } from "./eHabilitacao.vue?vue&type=template&id=052e204c&"
import script from "./eHabilitacao.vue?vue&type=script&lang=js&"
export * from "./eHabilitacao.vue?vue&type=script&lang=js&"
import style0 from "./eHabilitacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports